(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-install-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAccioInstallVideos() {
      var frames = document.querySelectorAll('[data-accio-video]');
      Array.prototype.forEach.call(frames, function (frame) {
        var button = frame.querySelector('.accio-install__play');
        if (!button || frame.getAttribute('data-accio-video-ready') === 'true') return;
        frame.setAttribute('data-accio-video-ready', 'true');

        button.addEventListener('click', function () {
          var source = frame.getAttribute('data-video-src');
          if (!source) return;

          var video = document.createElement('video');
          video.className = 'accio-install__video';
          video.setAttribute('controls', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('preload', 'metadata');
          video.setAttribute('controlsList', 'nodownload');

          var file = document.createElement('source');
          file.setAttribute('src', source);
          file.setAttribute('type', 'video/mp4');
          video.appendChild(file);

          frame.appendChild(video);
          button.remove();

          var playback = video.play();
          if (playback && typeof playback.catch === 'function') {
            playback.catch(function () {});
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccioInstallVideos);
    } else {
      initAccioInstallVideos();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
